import { Flex } from 'antd';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

// components
import StatusComponent from 'components/status/status';
import FilePreview from 'components/filePreview/filePreview';

// models
import { SadadPayment } from './commonModels';

// styles
import sadadLogo from 'assets/icons/sadad.png';

// services
import { formatFileSize } from 'utils/FileSize';
import { StatusColors } from 'utils/statusColors';

interface SadadInvoiceComponentProps {
	payment: SadadPayment;
}

const SadadInvoiceComponent: FunctionComponent<SadadInvoiceComponentProps> = ({ payment }) => {
	const { t } = useTranslation();

	return (
		<Flex gap={20} align="center">
			<div style={{ padding: 20, background: '#fff', border: '1px solid #eee', borderRadius: 'var(--radius)' }}>
				<img src={sadadLogo} alt="Sadad Logo" width={150} />
			</div>

			<div className="flex-grow-1">
				<Flex gap={10} align="center" justify="space-between" className="mb-2">
					<Flex align="center" gap={10}>
						<h6 className="mb-0 fw-medium">
							{t('ACTIONS.BILL_NUMBER')} #{payment?.invoice_no}
						</h6>
						<StatusComponent small text={t(`COMMON.${payment?.status_key.toUpperCase()}`)} color={StatusColors[payment?.status_key!]} />
					</Flex>

					<p className="mb-0 text-light">{payment?.expiry_date}</p>
				</Flex>

				<FilePreview
					name={payment.invoice?.title}
					downloadLink={payment.invoice?.download_link}
					data={formatFileSize(payment.invoice?.size_in_kilobyte!)}
					style={{ background: '#fff' }}
				/>
			</div>
		</Flex>
	);
};

export default SadadInvoiceComponent;
